import ErrorTrack from "lib/ErrorTrack";
import StripeErrors from "lib/StripeErrors";
import { get } from "underscore";

export default class StripeOnceOffFlow {
  constructor(stripeManager) {
    this.stripeManager = stripeManager;
  }

  /**
   * Executes a once-off Stripe payment, submitting the relevant details to the
   * backend using `submitForm()` and then completing payment using
   * `confirmCardPayment()`
   * @param paymentMethod a payment method provided by Stripe, e.g. as returned
   *   from `StripeManager.createPaymentMethod()`
   * @param donationDetails to be passed through to the TC-Donate backend when
   * submitting the donation. See `DonationFormManager.donationDetails`.
   * @return {Promise<unknown>}
   */
  async executePayment({ donationDetails, paymentMethod }) {
    ErrorTrack.leaveBreadcrumb("StripeOnceOffFlow.executePayment()", { paymentMethod });
    // If paymentMethod.id is missing, avoid making a payment intent call to our
    // server which will only fail by throwing. This will cause a generic error
    // to appear in the UI
    // (see https://app.bugsnag.com/the-conversation/tc-donations/errors/607bbd675c90fc000862c4a4)
    if (!paymentMethod.id) { throw new Error("Blank payment method ID"); }
    const { id: stripePaymentIntentId, client_secret: clientSecret } = await
      this.stripeManager.savePaymentIntent(paymentMethod.id);
    const stripePaymentMethodWalletType = get(paymentMethod, ["card", "wallet", "type"]);
    const paymentData = { stripePaymentIntentId, stripePaymentMethodWalletType };
    await this.stripeManager.submitForm({
      donationDetails,
      paymentTokens: { paymentData },
    });
    const cardPaymentResponse = await this.stripeManager.confirmCardPayment({ clientSecret });
    if (cardPaymentResponse.error) {
      throw StripeErrors(cardPaymentResponse);
    }
  }
}
